import React, {useContext} from 'react'
import {Root} from 'react-dom/client'

type Value = {
  rootElement: HTMLElement
  root: Root
}

type Props = Value & {
  children: React.ReactNode
}

export const RootContext = React.createContext<Value | null>(null)

export const RootProvider = ({children, ...other}: Props) => {
  return <RootContext.Provider value={other}>{children}</RootContext.Provider>
}

export const useRootContext = () => {
  const input = useContext(RootContext)

  if (!input) {
    throw new Error('Input is null')
  }

  return input
}

export const useRoot = () => {
  const {root} = useRootContext()
  return root
}

export const useRootElement = () => {
  const {rootElement} = useRootContext()
  return rootElement
}
